import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SkeletonModule } from "primeng/skeleton";

import { RestrictiveMeasureListSkeleton } from "../components/restrictive-measure-list.skeleton";

@Component({
	selector: "ic-restrictive-measures-overlay-skeleton",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [SkeletonModule, RestrictiveMeasureListSkeleton],
	templateUrl: "./restrictive-measures-overlay.skeleton.html",
})
export class RestrictiveMeasuresOverlaySkeleton {}
